// Load environment variables from .env file


// custom settings that work with our own OAuth server
const andreykaSettings = {
    authority: process.env.REACT_APP_AUTHORITY ,
    client_id: 'react-client',
    client_secret: '901564A5-E7FE-42CB-B10D-61EF6A8F3654',
    redirect_uri: process.env.REACT_APP_REDIRECT_URI || 'http://localhost:3000/oauth/callback',
    silent_redirect_uri: process.env.REACT_APP_SILENT_REDIRECT_URI || 'http://localhost:3000/oauth/callback',
    post_logout_redirect_uri: process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || 'http://localhost:3000/logout-success',
    response_type: 'code',
    // this is for getting user.profile data, when open id connect is implemented
    //scope: 'api1 openid profile'
    // this is just for OAuth2 flow
    scope: 'openid api1 profile email roles'
};
const config = {
    apiBaseUrl: process.env.REACT_APP_API_BASE_URL
};

export default config;
export const andreykaConfig = {
    settings: andreykaSettings,
    flow: 'andreyka'
};



